import './Accordion.scss'

import { IconCategory } from '@here/hds-iconlibrary/build/hds-iconlibrary'
import { HDSIcon } from '@here/hds-react-components'
import classNames from 'classnames'
import { config } from 'lib/config'
import React from 'react'

interface AccordionProps {
  title: string
  isExpanded: boolean
  icon?: string
  iconCategory?: IconCategory
  className?: string
  style?: React.CSSProperties
  children?: React.ReactNode
  labelColor?: string
  onToggle: (toggle: boolean) => void
}

export function Accordion({
  title,
  icon,
  isExpanded,
  iconCategory,
  className,
  style,
  children: content,
  onToggle,
  labelColor = 'var(--hds-foreground-primary)',
}: AccordionProps): JSX.Element {
  const handleHeaderClick = (): void => onToggle(!isExpanded)

  const labelStyle: React.CSSProperties = {
    color: labelColor,
  }

  return (
    <div
      className={classNames('Accordion', { 'Accordion--expanded': isExpanded }, className)}
      onClick={handleHeaderClick}
    >
      <header className="Accordion__header">
        <div className="Accordion__title">
          {icon !== undefined && (
            <HDSIcon name={icon} category={iconCategory} style={style} iconStyle="solid" />
          )}

          <span className="Accordion__title-label" style={labelStyle}>
            {title}
          </span>
        </div>

        <img
          className="Accordion__chevron-icon"
          src={`${config.ROOT_PATH}images/chevron-down.svg`}
        />
      </header>

      <div className="Accordion__content">{content}</div>
    </div>
  )
}
